var _rect, _rect2, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.3077,
    height: 26.3077,
    rx: 4,
    fill: "#20C3FF",
    fillOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 25.9077,
    height: 25.9077,
    rx: 3.8,
    stroke: "#20C3FF",
    strokeOpacity: 0.07,
    strokeWidth: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1142_14751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6034 13.016C21.58 12.9588 19.2938 7.15381 13.2279 7.15381C13.2028 7.15381 13.1776 7.15662 13.1525 7.1585C13.1274 7.15568 13.1022 7.15381 13.0771 7.15381C7.0112 7.15381 4.72229 12.956 4.70161 13.016C4.63519 13.1913 4.63519 13.3882 4.7061 13.5607C4.79766 13.7886 7.02005 19.1538 13.0772 19.1538H13.2289C19.2886 19.1538 21.5102 13.7885 21.6 13.5607C21.6683 13.3873 21.6701 13.1904 21.6036 13.016H21.6034ZM13.2251 17.7125H13.0734C8.60869 17.7125 6.59369 14.2846 6.09735 13.2747C6.58655 12.2236 8.60432 8.59402 13.0734 8.59402C13.0986 8.59402 13.1237 8.59121 13.1488 8.58934C13.174 8.59215 13.1991 8.59402 13.2242 8.59402C17.6961 8.59402 19.7111 12.2236 20.2003 13.2747C19.7058 14.2874 17.6878 17.7125 13.2251 17.7125Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1467 9.79443C11.373 9.79443 9.92969 11.3021 9.92969 13.1549C9.92969 15.0077 11.373 16.5154 13.1467 16.5154C14.9204 16.5154 16.3637 15.0077 16.3637 13.1549C16.3637 11.3021 14.9204 9.79443 13.1467 9.79443ZM13.1467 15.0752C12.1333 15.0752 11.3084 14.2135 11.3084 13.1549C11.3084 12.0963 12.1333 11.2346 13.1467 11.2346C14.1601 11.2346 14.985 12.0963 14.985 13.1549C14.985 14.2135 14.1601 15.0752 13.1467 15.0752Z",
    fill: "#20C3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1142_14751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5385,
    height: 17.5385,
    fill: "white",
    transform: "translate(4.38281 4.38452)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.6b064c141c7d75ab047916fb9a316c51.svg";
export { ForwardRef as ReactComponent };